/**
 * Brand colors
 */
export const brandColors = {
  green: "#9aeeda",
  lightGreen: "rgb(154, 238, 218)",
  teal: "#26a69a",
  grey: "#545c70",
  lightGrey: "#dfdbd4",
}
